import React, {useEffect, useMemo} from 'react'
import {Col, Row, Card} from 'react-bootstrap'
import CountUp from 'react-countup';
import {generateFakeTransactionsWithAlerts} from "../../../data/transactions";
import {COLORS} from "../../../Common/constants/colors";
import {useTranslation} from "react-i18next";
import {dashboardAPI} from "../../../services/api";

const AlertWidget = () => {
    const { t } = useTranslation();
    const [totalAlerts, setTotalAlerts] = React.useState<number>(0);
    const [reviewAlerts, setReviewAlerts] = React.useState<number>(0);
    const [closedAlerts, setClosedAlerts] = React.useState<number>(0);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    // Check if user is demo user
    const isDemoUser = useMemo(() => {
        const authUser = sessionStorage.getItem("authUser");
        if (!authUser) return false;
        try {
            const userData = JSON.parse(authUser);
            const token = userData.token || userData.access_token;
            return token?.startsWith('demo-token-') || userData.email === 'admin@demo.com.tr';
        } catch {
            return false;
        }
    }, []);

    useEffect(() => {
        if (isDemoUser) {
            // Use mock data for demo users
            const {alerts} = generateFakeTransactionsWithAlerts();
            setTotalAlerts(alerts.length);
            const reviewCount = alerts.filter((alert: Alert) => alert.status === "in_review").length;
            setReviewAlerts(reviewCount);
            const closedCount = alerts.filter((alert: Alert) => alert.status === "closed").length;
            setClosedAlerts(closedCount);
            return;
        }

        // Fetch alert counts from backend
        const fetchAlertCounts = async () => {
            setIsLoading(true);
            try {
                const response: any = await dashboardAPI.getAlerts({ page: 0, size: 10000 }); // Fetch all to count
                const alerts = response?.content || [];
                
                setTotalAlerts(alerts.length);
                const reviewCount = alerts.filter((alert: Alert) => alert.status === "in_review").length;
                setReviewAlerts(reviewCount);
                const closedCount = alerts.filter((alert: Alert) => alert.status === "closed").length;
                setClosedAlerts(closedCount);
            } catch (error) {
                console.error('Failed to fetch alert counts:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchAlertCounts();
    }, [isDemoUser]);

    return (
        <React.Fragment>
            <Row>
                <Col xl={4} md={6}>
                    <Card className="bg-primary">
                        <Card.Body>
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1">
                                    <h4 className={`fs-22 fw-semibold text-white  ff-secondary mb-2`}>
                                        <CountUp end={totalAlerts}></CountUp>
                                        <p className={`text-uppercase fw-medium fs-14 mb-0`}>{t('Alerts.total') + " " +t('Alerts.alert_count')}</p>
                                    </h4>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>

                </Col>
                <Col xl={4} md={6}>
                    <Card style={{backgroundColor: COLORS.WARNING}}>
                        <Card.Body>
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1">
                                    <h4 className={`fs-22 fw-semibold  ff-secondary mb-2`}>
                                        <CountUp end={reviewAlerts}></CountUp>
                                        <p className={`text-uppercase fw-medium fs-14 mb-0`}>{t('Alerts.in_review') + " " +t('Alerts.alert_count')}</p>
                                    </h4>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xl={4} md={6}>
                    <Card style={{backgroundColor: COLORS.SUCCESS}}>
                        <Card.Body>
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1">
                                    <h4 className={`fs-22 fw-semibold text-white  ff-secondary mb-2`}>
                                        <CountUp end={closedAlerts}></CountUp>
                                        <p className={`text-uppercase fw-medium fs-14 mb-0`}>{t('Alerts.closed') + " " +t('Alerts.alert_count')}</p>
                                    </h4>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default AlertWidget
